module.exports = __webpack_public_path__ + "img/questionBg.59f1fd94.png";